import React from "react";
import "react-quill/dist/quill.snow.css";
import styles from "./previewBox.module.scss";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

const PreviewBox = (props) => {
  const { pdfUrl } = props;

  return (
    <Box className={styles.blockWrapper1} data-testid="PreviewBox">
      <iframe
        src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
        title="PDF Preview"
        width="800px"
        height="600px"
        style={{ border: "none" }}
      >
      </iframe>
    </Box>
  );
};
export default PreviewBox;
PreviewBox.propTypes = {
  pdfUrl:PropTypes.any
}